export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LANGUAGE ?? 'lt';
